<header class="welcome-planner-view__header">
  <h1 class="welcome-planner-view__title ci-heading-h2-bold">
    {{ 'Te damos la bienvenida al planificador' | translate }}
  </h1>
  <p class="welcome-planner-view__subtitle ci-paragraph-p1-semibold">
    {{ 'Aquí encontrarás todos los lugares que Cicerone ha seleccionado para ti, organizados en una práctica línea de tiempo para que tu recorrido sea más fácil de seguir' | translate }}
  </p>
</header>